<div class="container-fluid" style="margin-bottom: 5px; margin-top: 10px">
  <div class="row">
    <div class="col-2">
      <button type="button" style="font-size: 18px" class="btn btn-labeled btn-success" (click)="changeScreenToInputOrder()">
        <span class="btn-label"><i class="fas fa-plus-circle"></i></span> Adăugare Comandă
      </button>
    </div>
    <div class="col-4"></div>
    <div class="col-4">
      <input type="text" ngModel="{{currentOrderSearchWord}}" class="form-control" style="font-family: FontAwesome;"  title="Căutare" id="searchBar" placeholder="&#xF002;" (ngModelChange)="refreshAfterSearch(searchWord.value)" #searchWord>
    </div>
    <div class="col-2"></div>
  </div>
</div>

<div class="container-fluid table-responsive" style="padding: 1%">
  <table class="table">
    <thead>
    <tr>
      <th scope="col" style="width: 7%">
        <div>
          PO
          <button class="btn btn-default" (click)="changeSortOnPO()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentOrderSortColumn == 'PO' && currentOrderSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentOrderSortColumn == 'PO' && !currentOrderSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 12%">
        <div>
          Număr de Factură
          <button class="btn btn-default" (click)="changeSortOnNumarFactura()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentOrderSortColumn == 'NUMARFACTURA' && currentOrderSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentOrderSortColumn == 'NUMARFACTURA' && !currentOrderSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 12%" *ngIf="!isMobile">
        <div>
          Condiție de Livrare
          <button class="btn btn-default" (click)="changeSortOnConditieLivrare()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentOrderSortColumn == 'CONDITIELIVRARE' && currentOrderSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentOrderSortColumn == 'CONDITIELIVRARE' && !currentOrderSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 10%">
        <div>
          Data Recepției
          <button class="btn btn-default" (click)="openDatePicker(modalDate)"><i class="bi bi-calendar-range"></i></button>
          <button class="btn btn-default" (click)="changeSortOnDataReceptie()"><i class="bi bi-sort-alpha-down"></i></button>
          <i *ngIf="currentOrderSortColumn == 'DATARECEPTIE' && currentOrderSortDesc" class="bi bi-arrow-down"></i>
          <i *ngIf="currentOrderSortColumn == 'DATARECEPTIE' && !currentOrderSortDesc" class="bi bi-arrow-up"></i>
        </div>
      </th>
      <th scope="col" style="width: 7%" *ngIf="!isMobile">
        <div>
          Stare
          <button class="btn btn-default" (click)="openStateFilter(modalState)"><i class="bi bi-funnel-fill"></i></button>
        </div>
      </th>
      <th scope="col" style="width: 12%"> </th>
    </tr>
    </thead>
    <tbody *ngFor="let order of orders">
    <tr>
      <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" [ngStyle]="smallFont(isMobile)">{{order.PO}}</td>
      <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" [ngStyle]="smallFont(isMobile)">{{order.NumarFactura}}</td>
      <td *ngIf="!isMobile" style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;">{{order.ConditieLivrare}}</td>
      <td style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" [ngStyle]="smallFont(isMobile)">{{order.DataReceptie.slice(0, 10)}}</td>
      <td *ngIf="!isMobile" style="white-space: nowrap; text-overflow:ellipsis; overflow: hidden; max-width:1px;" >
        <select class="custom-select" *ngIf="order.Stare=='Confirmată'" (change)="onChangeState($event, order)">
          <option selected>Confirmată</option>
          <option>În lucru</option>
          <option>Anulată</option>
        </select>
        <select class="custom-select" *ngIf="order.Stare=='În lucru'" (change)="onChangeState($event, order)">
          <option selected>În lucru</option>
          <option>Confirmată</option>
          <option>Anulată</option>
          <option>Finalizată</option>
        </select>
        <select class="custom-select" *ngIf="order.Stare=='Anulată'" (change)="onChangeState($event, order)">
          <option selected>Anulată</option>
          <option>În lucru</option>
          <option>Confirmată</option>
        </select>
        <select class="custom-select" *ngIf="order.Stare=='Finalizată'" (change)="onChangeState($event, order)">
          <option selected>Finalizată</option>
          <option>În lucru</option>
        </select>
      </td>
      <td>
        <button type="button" class="btn btn-secondary" style="margin: 1%" title="Modificare" (click)="editOrder(order)" *ngIf="(order.Stare=='În lucru' || order.Stare=='Confirmată')"><i class="far fa-edit"></i></button>
        <button type="button" class="btn btn-secondary" style="margin: 1%" title="Modificare" *ngIf="order.Stare!='În lucru' && order.Stare!='Confirmată' && !isMobile" disabled><i class="far fa-edit" ></i></button>
        <button type="button" class="btn btn-danger" style="margin: 1%" title="Ștergere" (click)="deleteOrder(order)" *ngIf="order.Stare=='Anulată' && !isMobile"><i class="bi bi-trash"></i></button>
        <button type="button" class="btn btn-danger" style="margin: 1%" title="Ștergere" *ngIf="order.Stare!='Anulată'  && !isMobile" disabled><i class="bi bi-trash" ></i></button>
        <button type="button" class="btn btn-info" style="margin: 1%" title="Prelucrare" (click)="processOrder(order)" *ngIf="order.Stare=='În lucru'"><i class="bi bi-box-seam"></i></button>
        <button type="button" class="btn btn-info" style="margin: 1%" title="Prelucrare" *ngIf="order.Stare!='În lucru'  && !isMobile" disabled><i class="bi bi-box-seam"></i></button>

        <button type="button" *ngIf="order.Stare=='Finalizată' && !isMobile" class="btn btn-success dropdown-toggle" id="dropdownMenuButton" style="margin: 1%" title="Descărcare raport" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-file-export"></i></button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="{{hrefReport}}{{order.Id}}">Raport comandă</a>
            <a class="dropdown-item" href="{{hrefReportPO}}{{order.PO}}">Raport PO</a>
          </div>
        <button type="button" class="btn btn-success" style="margin: 1%" title="Descărcare raport" *ngIf="order.Stare!='Finalizată'  && !isMobile" disabled><i class="fas fa-file-export"></i></button>
      </td>
    </tr>
  </table>

  <div *ngIf="numberOfOrderPages > 1" class="container">
    <div class="container-fluid col-12">
      <div class="row">
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToFirstPage()"><i class="bi bi-chevron-double-left"></i></button>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPage()"><i class="bi bi-chevron-left"></i></button>
        <div style="margin: 4px; font-size: 19px">{{currentOrderPage}} / {{numberOfOrderPages}}</div>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPage()"><i class="bi bi-chevron-right"></i></button>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToLastPage()"><i class="bi bi-chevron-double-right"></i></button>
      </div>
    </div>
  </div>

</div>


<ng-template #modalDate let-modalDate>
  <div class="modal-header">
    <h4 class="modal-title">Interval Dată de Recepție</h4>
  </div>
  <div class="modal-body">
    <mat-form-field appearance="fill">
      <mat-label>Alege un interval de timp</mat-label>
      <mat-date-range-input [formGroup]="intervalReceptie" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start date">
        <input matEndDate formControlName="end" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker touchUi #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="modalDate.dismiss()"><i class="far fa-times-circle"></i> Anulare</button>
    <button type="button" class="btn btn-success" (click)="applyDateFilter(modalDate)"><i class="bi bi-check-lg"></i> Aplicare</button>
  </div>
</ng-template>

<ng-template #modalState let-modalState>
  <div class="modal-header">
    <h4 class="modal-title">Filtrarea Comenzilor după Stare</h4>
  </div>
  <div class="modal-body">
    <mat-form-field appearance="fill">
      <mat-label>Stări</mat-label>
      <mat-select [formControl]="stari" multiple>
        <mat-option *ngFor="let stare of listaStari" [value]="stare[0]">{{stare[1]}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="modalState.dismiss()"><i class="far fa-times-circle"></i> Anulare</button>
    <button type="button" class="btn btn-success" (click)="applyStateFilter(modalState)"><i class="bi bi-check-lg"></i> Aplicare</button>
  </div>
</ng-template>
